import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCoreFacade } from "../../../core/facades/Core.facade";
import { HomeHeaderProfileMenuConstants } from "../../models/constants/home-header-profile-menu.constants";
import { IHomeHeaderProfileMenu } from "../../models/interfaces/home-header-profile-menu.interface";
import HomeHeaderProfileMenu from "../../presentations/HomeHeaderProfileMenu";

const HomeHeaderProfileMenuContainer = () => {
  const { t } = useTranslation();
  const coreFacade = useCoreFacade();

  const IMG = (imgName: string) => {
    return require(`./../../../../../../assets/icons/profile-menu/${imgName}.svg`)
      ?.default;
  };

  const user = {
    firstName: "Amit",
    lastName: "Chaudhary",
    emailId: "amit.chaudhary@praxicaltech.com",
  };

  return (
    <div className="w-full">
      <div className="flex mt-2 mb-4">
        <div className="flex items-center">
          <div className="flex items-center justify-center ml-2 mr-2 bg-blue-700 rounded-full lg:ml-0 w-14 h-14 lg:w-10 lg:h-10">
            <span className="font-semibold text-white text-md">
              {coreFacade.getInitialsOfFullName(user.firstName, user.lastName)}
            </span>
          </div>
          <div>
            <div className="font-medium text-blue-700 cursor-pointer text-md">
              {coreFacade.getFullName(user.firstName, user.lastName)}
            </div>
            <div className="flex flex-col text-xs font-medium tracking-wide text-gray-400 lg:divide-x-2 lg:flex-row">
              <div className="mb-1 lg:pr-2 lg:mb-0">{user.emailId}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-4 border-b">
        {HomeHeaderProfileMenuConstants.Menu.map(
          (menu: IHomeHeaderProfileMenu, index: number) => (
            <HomeHeaderProfileMenu key={index} menu={menu}></HomeHeaderProfileMenu>
          )
        )}
      </div>

      <div className="flex py-2 mt-2 cursor-pointer">
        <span className="mx-4">
          <img className="h-4" src={IMG("logout")} alt="" />
        </span>
        <span className="text-xs font-semibold">
          {t("homeHeader.profile.action.logout")}
        </span>
      </div>
    </div>
  );
};

export default HomeHeaderProfileMenuContainer;
